export const INVALID_SYMBOLS = ['<', '>', '(', ')', ';', '+'];
export const RENAMING_ERRORS = {
  EXISTING_UTM: 'existingUTM',
  EDITABLE_EXISTING_UTM: 'editableExistingUTM',
  EXISTING_NAME: 'existingName',
  GENERIC: 'generic'
};